import { LoadingBadge } from './loadingBadge';

export const LoadingTripBoxes = () => {
  return (
    <div className="m-auto max-w-[70%] grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-20">
      {[{}, {}].map((_, index) => (
        <div key={index} className="flex flex-col items-start group relative">
          <div className="relative w-full">
            <div
              className="aspect-video w-full rounded-2xl animate-pulse bg-gray-300 object-cover sm:aspect-[2/1]
                        lg:aspect-[3/2]"
            />
          </div>
          <div className="w-full">
            <div className="group relative">
              <div className="relative mt-3 flex items-center gap-x-4">
                <div className="size-10 rounded-full bg-gray-300 animate-pulse" />
                <div className="flex flex-col">
                  <LoadingBadge
                    expectedChars={12}
                    className="text-lg/6 font-semibold text-gray-900 group-hover:text-gray-600"
                  />
                  <div className="flex items-center gap-x-1 text-xs">
                    <LoadingBadge expectedChars={7} className="" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};
